import { createClient } from '@supabase/supabase-js';

/* The Supabase client, as a singleton.

   Both values below are safe in the bundle and are meant to be. The anon key is
   a public identifier, not a secret — row-level security is what actually keeps
   one account out of another's data, and it runs on the server where the browser
   cannot reach it. The keys that must never appear here are service_role and
   Paddle's webhook signing secret; those belong in Edge Function secrets
   (supabase/functions/paddle-webhook), never a VITE_ variable.

   The app has to keep working with no backend configured. Cloud storage is an
   addition to Illusio, not a precondition for using it, so an unconfigured build
   runs exactly as before with local file open/save. */

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isConfigured = Boolean(url && anonKey);

export const supabase = isConfigured
  ? createClient(url, anonKey, {
      auth: {
        // A magic-link callback lands back on the app with the session in the
        // URL; picking it up automatically is what makes that a single click.
        detectSessionInUrl: true,
        persistSession: true,
        autoRefreshToken: true
      }
    })
  : null;

if (!isConfigured) {
  console.info(
    '[illusio] No Supabase credentials — running local-only. ' +
    'Copy .env.example to .env.local and fill in VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to enable accounts.'
  );
}

/** Throw with something readable rather than dereferencing null. */
export function requireClient() {
  if (!supabase) throw new Error('Cloud features need Supabase credentials in .env.local.');
  return supabase;
}
